import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import format from 'date-fns/format';
import { loginRouteWithSlash } from 'src/app/route-constants';
import { AppInsightsService } from '../services/app-insights.service';
import { GlobalModalWindowService } from '../services/global-modal-window.service';
import { GoogleAnalyticsService } from '../services/google-tag-manager.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone, private router: Router,
    private appInsightsService: AppInsightsService,
    private globalModalWindowService: GlobalModalWindowService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  handleError(error: any) {
    console.error(error);
    // Redirect to login page if PGH API returns 401
    if(error['status'] === 401 && error['error'] === 'Access Denied') {
      this.router.navigate([loginRouteWithSlash]);
    } else {
      let httpError;
      let showModalWindow = true;

      if (error && error.ErrorId) {
        httpError = error;
      } else if (error.error && error.error.ErrorId) {
        httpError = error.error;
      } else {
        httpError = error;
        // Check GraphQL Error Format
        if (error.error && error.error.errors && error.error.errors[0]) {
          httpError = error.error;
          showModalWindow = true;
          let message = this.concatenateErrorsMessages(error.error);
          //transform into PGH Error Format
          error.error.ErrorId = this.generateErrorId();
          error.error.Source = "GraphQL";
          error.error.ExceptionType = error.error?.errors[0]?.extensions.code;
          httpError.ErrorCode = 'Elita'+error.error?.errors[0]?.extensions?.elitaErrorCode;
          error.error.Message = message;
          if (error.error.data && error.error.data.devices) {
            showModalWindow = false;
          }
        } else {
          error.ErrorId = `PGH-UI-${format(new Date(), "yyyyMMdd-HHmmssSSS")}`
          showModalWindow = false;
        }
      }
      this.appInsightsService.logException(httpError);
      if (httpError.Message || httpError.ExceptionType || httpError.ErrorCode) {
        this.googleAnalyticsService.emitErrorEvent(httpError.Message, httpError.ExceptionType, httpError.ErrorCode);
      }
      if (showModalWindow) {
        this.globalModalWindowService.displayErrorModal(error['status'], httpError);
      }
    }
  }

  concatenateErrorsMessages(json: any): string {
    if (!json || !json.errors || !Array.isArray(json.errors)) {
      return ''; // Return an empty string if the input is not valid.
    }
    const messages: string[] = json.errors.map((error: any) => error.message);
    return messages.join('\n'); // Concatenate the messages with newline characters.
  }

  generateErrorId() {
    let reqId = `PGH-GraphQL-${format(new Date(), "yyyyMMdd-HHmmssSSS")}`;
    return reqId;
  }
}
